import { render, staticRenderFns } from "./preview-image.vue?vue&type=template&id=367bc6e0&scoped=true&"
import script from "./preview-image.vue?vue&type=script&lang=js&"
export * from "./preview-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367bc6e0",
  null
  
)

export default component.exports